import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Documento from './Media/Documento';
import SwitchableVideoPlayer from './Media/SwitchableVideoPlayer';
import Praticar from './Media/Praticar';
import Scorm from './Media/Scorm';
import Podcast from './Media/Podcast';
import RedirectMessage from './Media/RedirectMessage';
import Survey from './Media/Survey';
import OfficeDocumento from './Media/OfficeDocumento';
import { getOfficeFileKind } from '../../utils/officeFile';
import { gateway } from '../../utils/api';

import { Creators as CourseActions } from '../../store/ducks/newCourse/actions';

// O viewer do Office não expõe página nem fim de leitura: abrir o item já o conclui.
// Mesmo payload do Documento.endOfFile.
function completeOfficeContent(
  selected,
  { courseSession, incrementCourseProgress, setDisciplineProgress }
) {
  const wkStatus = _.get(selected, 'contentProgress.ox_status.wk_status');
  if (
    selected.typeContent === 'about' ||
    wkStatus === 'DONE' ||
    wkStatus === 'DONE_SELF_ASSESSMENT'
  ) {
    return;
  }

  const idProfile = parseInt(localStorage.getItem('idProfile'), 10);
  const { code, courseCode } = selected;

  gateway
    .post('/webbff/lit_app_web/progress/saveProgress', {
      idProfile,
      hierarchy: selected.hierarchy,
      courseCode,
      contentCode: code,
      position: 1,
      status: 'DONE'
    })
    .then(response => {
      const circle = document.getElementById(`course-object-${code}`);
      if (circle) circle.classList.add('active');
      const progress = _.get(response, 'progress', []);
      const foundObject = progress.find(p => p.rk_reference === code);
      incrementCourseProgress(_.get(foundObject, 'wk_status'));
      setDisciplineProgress(selected.idDiscipline);
    })
    .catch(() => {});

  gateway.post('/webbff/lit_app_web/course_progress/course_progress_object/', {
    selected: { code, courseCode },
    idProfile,
    courseSession: localStorage.getItem('session') || courseSession,
    action: 'DONE',
    status: 'DONE',
    type: 'PDF',
    position: 1
  });
}

const Media = ({
  setCourseSelected,
  incrementCourseProgress,
  setDisciplineProgress,
  course,
  courseSession,
  selected
}) => {
  const [openScorm, setOpenScorm] = useState(false);

  function getContentByCode(content, targetContent) {
    if (content.code === targetContent) {
      return content;
    }

    if (content.children) {
      for (const childNode of content.children) {
        const desiredNode = getContentByCode(childNode, targetContent);
        if (desiredNode) return desiredNode;
      }
    }

    return false;
  }

  function openScormCallback() {
    setOpenScorm(true);
  }

  function closeScorm() {
    setOpenScorm(false);
  }

  useEffect(() => {
    if (course.lastDispatchedContentCode) {
      const lastDispatchedContent = getContentByCode(
        course,
        course.lastDispatchedContentCode
      );

      if (
        lastDispatchedContent &&
        lastDispatchedContent.contentProgress &&
        lastDispatchedContent.contentProgress.ox_status
      ) {
        setCourseSelected(lastDispatchedContent);
      }
    }
  }, []);

  // A extensão da URL tem prioridade sobre media.type: arquivos Office
  // cadastrados como PDF cairiam no Documento, que baixa o arquivo.
  const isOfficeFile =
    Boolean(getOfficeFileKind(selected.url)) ||
    ['DOC', 'DOCX', 'XLS', 'XLSX', 'PPT', 'PPTX'].includes(selected.type);

  useEffect(() => {
    if (!isOfficeFile || !selected.code) return;
    completeOfficeContent(selected, {
      courseSession,
      incrementCourseProgress,
      setDisciplineProgress
    });
  }, [selected.code]);

  let media;
  if (isOfficeFile) {
    media = (
      <OfficeDocumento
        key={selected.code}
        fileUrl={selected.url}
        fileName={selected.name}
      />
    );
  } else {
    switch (selected.type) {
      case 'VIDEO':
      case 'VOD':
        media = <SwitchableVideoPlayer />;
        break;
      case 'PODCAST':
        media = <Podcast />;
        break;
      case 'PDF':
        media = <Documento />;
        break;
      case 'ANGLO_URL':
      case 'REDIRECT':
        media = <RedirectMessage />;
        break;
      case 'VMP':
        media = <Praticar />;
        break;
      case 'SCORM':
      case 'HTML':
      case 'TEL':
        media = <Scorm openScorm={openScorm} onOpen={closeScorm} />;
        break;
      case 'SURVEY':
        media = <Survey key={selected.code} />;
        break;
      default:
        media = null;
        break;
    }
  }

  return (
    <div className={`col-lg-${selected.type === 'SCORM' ? '12' : '8'}`}>
      <div className="row">
        <div className="container-fluid" style={{ height: '100%' }}>
          {media}
          {selected.type === 'TEL' && (
            <div
              className="card"
              style={{
                fontWeight: 'bold',
                fontSize: '1.1em',
                margin: '.7rem 0rem',
                border: '1px solid #ddd'
              }}
            >
              <button
                type="button"
                style={{ margin: 15, alignSelf: 'center' }}
                className="btn btn-blue btn-FontWeight6"
                onClick={openScormCallback}
              >
                Abrir
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  selected: state.newCourse.selected,
  course: state.newCourse.data,
  courseSession: state.newCourse.courseSession
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(CourseActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Media);
